import { render, staticRenderFns } from "./spaceRequestsOffer.vue?vue&type=template&id=e832cfe0&scoped=true&"
import script from "./spaceRequestsOffer.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsOffer.vue?vue&type=script&lang=js&"
import style0 from "./spaceRequestsOffer.vue?vue&type=style&index=0&id=e832cfe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e832cfe0",
  null
  
)

export default component.exports